import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';
import {PwaLandingService} from '../../services/pwa-landing.service';
import {HeaderService} from '../../services/header.service';

const GROUP_ROUTE = '/dashboard/groups';

@Component({
  selector: 'app-pwa-dashboard-landing',
  template: '<app-home-tasks *ngIf="!landing.isHeadLanding"></app-home-tasks>' +
    '<section *ngIf="landing.isHeadLanding" class="pwa-landing" aria-live="polite">' +
    '<p *ngIf="loading">{{ "LOADING" | translate }}</p>' +
    '<div *ngIf="failed" role="alert"><p>{{ "PWA_PRIMARY_GROUP_UNAVAILABLE" | translate }}</p>' +
    '<button type="button" class="btn btn-secondary" (click)="load()">{{ "RETRY" | translate }}</button> ' +
    '<a class="btn btn-primary" routerLink="/dashboard/groups">{{ "MY_DEPARTMENTS" | translate }}</a></div></section>',
  styles: ['.pwa-landing { padding: 24px 16px; } .btn { min-height: 44px; white-space: normal; }']
})
export class PwaDashboardLandingComponent implements OnInit, OnDestroy {
  loading = false;
  failed = false;
  private destroyed$ = new Subject<void>();

  constructor(public landing: PwaLandingService, private router: Router, private header: HeaderService) {}

  ngOnInit(): void {
    if (!this.landing.isHeadLanding) { return; }
    this.header.showSideMenu();
    this.header.showTaskMenu();
    this.header.showUsername();
    this.load();
  }
  ngOnDestroy(): void { this.destroyed$.next(); this.destroyed$.complete(); }

  load(): void {
    if (this.loading) { return; }
    this.loading = true;
    this.failed = false;
    this.landing.primaryDepartment().takeUntil(this.destroyed$).subscribe(id => {
      this.router.navigate([GROUP_ROUTE, id], {replaceUrl: true}).then(success => {
        this.loading = false;
        this.failed = !success;
      }, () => this.reject());
    }, () => this.reject());
  }

  private reject(): void { this.loading = false; this.failed = true; }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/pwa/pwa-dashboard-landing.component.ts